import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { IconMeeting } from '@amtrav/icons';
import { media } from '@amtrav/theme-system';
import { shortDayMonthDate } from '@amtrav/dates';
import { IconFlex, Button, Card } from '@amtrav/view-components';

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
`;

const CardContainer = styled.div`
  margin-bottom: 48px;
`;

const CardInterior = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonContainer = styled.div`
  margin-left: auto;
  width: 64px;
`;

const DateContainer = styled.div`
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 600;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;

  display: inline-block;
  background-color: #e6e6e6;
  padding: 4px;
  margin-top: 8px;
  margin-bottom: 16px;
  margin-left: 16px;
  ${media.Medium`
    left: -16px;
    margin-left: 0px;
  `}
`;

const MeetingName = styled.div`
  margin-bottom: 6px;
  font-family: 'Public Sans', Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
`;

const MeetingLocation = styled.div`
  font-family: 'Public Sans', Helvetica, Arial, sans-serif;
  padding: 0;
  line-height: 1.4;
  text-transform: uppercase;
  padding-top: 2px;
  letter-spacing: 0.1em;
  font-weight: 600;
  font-size: 12px;
  margin: 0 0 4px 0;
`;

const TextContainer = styled.div`
  display: inline-block;
  padding-left: 20px;
`;

const HandleClick = (dest) => {
  document.location = dest;
};

const InvitesPreview = ({ invites = [] }) => {
  if (invites === null) {
    return null;
  }
  if (invites.length !== 0) {
    return (
      <CardsContainer>
        {invites.map((invite) => {
          const formattedStartDate = shortDayMonthDate(invite.startDate);
          return (
            <CardContainer key={invite.title}>
              <DateContainer>{formattedStartDate}</DateContainer>
              <Card>
                <Card.Body>
                  <CardInterior>
                    <IconFlex size={25}>
                      <IconMeeting />
                    </IconFlex>
                    <TextContainer>
                      <MeetingName>{invite.title}</MeetingName>
                      <MeetingLocation>{invite.location}</MeetingLocation>
                    </TextContainer>
                    <ButtonContainer>
                      <Button
                        text="View"
                        size="small"
                        fullWidth
                        onClick={() => {
                          HandleClick(invite.link);
                        }}
                      />
                    </ButtonContainer>
                  </CardInterior>
                </Card.Body>
              </Card>
            </CardContainer>
          );
        })}
      </CardsContainer>
    );
  }
};

InvitesPreview.propTypes = {
  /**
   * Name of the Traveler that the tickets belong to
   */
  travelerName: PropTypes.string,
  /**
   * Array of tickets from the TravelerConfig
   */
  tickets: PropTypes.arrayOf(
    PropTypes.shape({
      airlineCode: PropTypes.string,
      airline: PropTypes.string,
      creditValue: PropTypes.number,
      expiresDate: PropTypes.string,
    }),
  ),
  /**
   * Controls whether on small screens, component collapses into accordion
   */
  collapsible: PropTypes.bool,
};

export default InvitesPreview;
